import React, { useState } from "react";
import { fetchWrapper } from "../../helpers";

const DownloadReportButton = ({ organizationId }) => {
    const [loading, setLoading] = useState(false);
    const baseUrl = `${process.env.REACT_APP_API_URL}`;

    const handleDownload = async () => {
        setLoading(true);
        try {
            const response = await fetchWrapper.get(`${baseUrl}/organizations/${organizationId}/post-report`, null, { raw: true });

            if (!response.ok) throw new Error("PDF download failed");

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `organization_${organizationId}_post_report.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download error:", error);
            alert("There was an error downloading the PDF.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <button className="logout-button max-w-fit max-w-max mx-auto mb-2.5" onClick={handleDownload} disabled={loading}>
            {loading ? "Создаем отчет..." : "Отчет по публикациям"}
        </button>
    );
};

export default DownloadReportButton;
